export enum TRIGGER_TYPE {
  REAL_TIME_BASED = 'REAL_TIME_BASED',
  VALUE_BASED = 'VALUE_BASED',
  OPC_OFFLINE = 'OPC_OFFLINE',
  OPC_NO_DATA = 'OPC_NO_DATA',
}